import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ServiceSchedule } from 'src/services/api-services/api-interfaces/api-interface-service-schedule';
import { CustomSchedule } from 'src/services/api-services/api-interfaces/custom-schedule.interface';
import { Scheduler } from 'src/services/api-services/api-interfaces/scheduler.interface';
import { HelperService } from 'src/services/helperService';
import { APICustomScheduleService } from 'src/services/api-services/api-custom-schedule-service';
import { APISchedulerService } from 'src/services/api-services/api-scheduler-service';
import { CancelAppointmentComponent } from 'src/app/WebView/FormWebView/query/consultant-form/cancel-appointment/cancel-appointment.component';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { VehicleData } from '../../../../../services/api-services/api-interfaces/vehicleData.interface';
import { APIcityService } from '../../../../../services/api-services/api-city-service';
import { EMPTY, Subscription, catchError, throwError } from 'rxjs';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PublicSiteConfig } from 'src/services/publicSiteConfig.service';
import { InformationModalComponent } from 'src/app/WebView/FormWebView/query/consultant-form/information-modal/information-modal.component';
import { PublicSiteConfigBaseComponent } from 'src/app/base/publicSiteConfigBase.component';


@Component({
    selector: 'app-consultant-form',
    templateUrl: './consultant-form.component.html',
    styleUrls: ['./consultant-form.component.sass'],
    standalone: false
})
export class ConsultantFormComponent extends PublicSiteConfigBaseComponent implements OnInit, OnDestroy {
 
  isAppointmentCanceled = false;
  canceledMessage: string = '';
  customerScheduleSubscribe?: Subscription
  schedulerData: any[] = [];
  SchedulerDetailsResp: Scheduler[] = [];
  scheduleAttentionServiceResp: ServiceSchedule[] = [];
  customData!:CustomSchedule[];
  plateNumberSearch: string = '';
  public appointments: any[] = [];
  displayDate = new Date();
  public selectDate: Date = this.displayDate;
  customScheduleServiceResp: CustomSchedule[] = [];
  typeOfService: string = "";
  workshops: string[] = [];
  advisor: string[] = [];
  fecha: string[] = [];
  customScheduleResp: any[]= [];
  vehicleData: VehicleData[]= [];
  inputPlate:string="";
  mileage
  scheduleId: any;
  recievedLanguageForCountry:any = history.state.LanguageForCountry as {}
  utmParams:any = history.state.utmParams as {}
  editScheduleUrl: string=''
  numberAppointments: number = 0
  public showMessageNotFound: boolean = false;
  loadingSerchPlate:boolean = false
  imagen_banner :any;
  customerSchedules$ 
  scheduledAppointments :any[]=[]
  showLastName:boolean = false
  index :any[]=[];
  formValidation = this.formBuilder.group({
    document:['', {
      validators: [Validators.required, Validators.pattern(/[a-zA-Z0-9\s\-.,_]/),Validators.minLength(5)]
    }],
    placa:['', [Validators.required, Validators.pattern(/[a-zA-Z0-9\s\-.,_]/)]]
  });
  dato = this.formValidation
  cityId?:number
  results: any[] = []
  subscriptionComplete: boolean=false
  visibleAppointments: any[] = []
  hasMoreAppointments: boolean = true
  currentPage: number = 1;

  get cedulaControl(): FormControl{
    return this.formValidation.get('document') as FormControl;
  }
  get placaControl(): FormControl{
    return this.formValidation.get('placa') as FormControl;
  }
  
  constructor(private formBuilder: FormBuilder,
    public helperService: HelperService,
    public customScheduleService: APICustomScheduleService,
    public schedulerService: APISchedulerService,
    public dialog: MatDialog,
    public cityServiceApi: APIcityService,
    private translate: TranslateService,
    public override publicSiteConfig: PublicSiteConfig,
    private router: Router,private route: ActivatedRoute,) { 
      super(publicSiteConfig);

      if(!this.indexbrand || !this.indexCountry){
        this.route.params.subscribe(params => {
          this.indexbrand = params['brand'];
          this.indexCountry = params['country'];
        });
        const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`
        this.router.navigate([bannermanagementURL]);  
      }
      this.editScheduleUrl= `/WebView/FormWebView/choose-service-workshop/${this.indexbrand}/${this.indexCountry}`;    
  }
  
  protected override afterConfigLoaded(): void {
    this.imagen_banner = this.CurrentBrand.imagen_banner2;
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.customerScheduleSubscribe?.unsubscribe()
    
  }

  isDisabledAppointment(scheduledAppointment: any): boolean {
    const currentDate = new Date()
    const LimitDate = new Date(currentDate.getTime() + 5 * 60000);
    const dateAppointment = new Date(scheduledAppointment.start)

    return dateAppointment <= LimitDate;
  }

  editSchedule(scheduledAppointment: any): void {
    if (this.isDisabledAppointment(scheduledAppointment)) {
      this.openDialogInformation(scheduledAppointment);
      return;
    }
    const state = {
      schedule: scheduledAppointment,
      cityName: scheduledAppointment.department,
      brand: scheduledAppointment.brandId,
      cityId: scheduledAppointment.cityId,
      country: this.indexCountry,
      LanguageForCountry: this.recievedLanguageForCountry,
      utmParams: this.utmParams
    }
    this.router.navigate([this.editScheduleUrl], {
      state,
    });
  }

  onClearClick() {
    this.formValidation.reset();
    this.loadingSerchPlate = false
  }
  
  onplateNumberSearchClick() {
    // Validate special characters in the document
    let documentValue = String(this.formValidation.value.document)
    if (this.containsSpecialCharacters(documentValue)) {
      const translateTxtSpecialChars = this.translate.instant("specialCharsError");
      this.helperService.showAlert =true
            this.helperService.typeAlert ="error"
            this.helperService.messageAlert =translateTxtSpecialChars
            setTimeout(() => {
              this.helperService.showAlert =false
              }, 7000)
      return; 
    }
    // Validate special characters in the plate
    let plateValue = String(this.formValidation.value.placa)
    if (this.containsSpecialCharacters(plateValue)) {
      const translateTxtSpecialChars = this.translate.instant("specialCharsError");
      this.helperService.showAlert =true
            this.helperService.typeAlert ="error"
            this.helperService.messageAlert =translateTxtSpecialChars
            setTimeout(() => {
              this.helperService.showAlert =false
              }, 7000)
      return; 
    }

    this.loadingSerchPlate = true
    this.customerSchedules$=this.customScheduleService.getByPlateIdentification("1",String(this.formValidation.value.placa),String(this.currentPage),"20",String(this.formValidation.value.document) ).pipe( catchError((error: any) => {
      if(error.status === 401){
        const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`
        this.router.navigate([bannermanagementURL]);
        this.helperService.TokenBooking = ''
      }else{
        // Handle validation error here
        console.error('Validation Error:', error);
        // Rethrow the error to propagate it downstream
        return throwError(error);
      }
      return EMPTY 
      
    }))
    this.customerScheduleSubscribe = this.customerSchedules$.subscribe({
      next:(response)=>{   
        
        if(response === null){  const translateTxtNotMatch = this.translate.instant("notMatchFound") 

          this.helperService.showAlert =true
          this.helperService.typeAlert ="error"
          this.helperService.messageAlert =translateTxtNotMatch
          setTimeout(() => {
            this.helperService.showAlert =false
            }, 7000)

          this.loadingSerchPlate = false}
          else{
        if(response[0]) {
          response.sort((a, b) => new Date(b.start).getTime() - new Date(a.start).getTime())
          this.scheduledAppointments = response
          this.scheduledAppointments[0].clientLastName === 'NaN'? this.showLastName = false:true
          this.numberAppointments= this.scheduledAppointments.length
          this.visibleAppointments = [...this.scheduledAppointments];
          this.hasMoreAppointments = true;
          this.currentPage = 1;
          this.scheduledAppointments.forEach((element) => {
          let date= element.start.split('T')[0]
          let time = element.start.split('T')[1]
          let formatTime = moment(time, 'HH:mm:ss').format('hh:mm A.')
          let splitTime=formatTime.split(' ')
          let customFormat= `${splitTime[0]} ${splitTime[1][0]}.${splitTime[1][1]}.`
          element.time= customFormat
          element.startDate = moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
          element.consultedSchedule=true
        })
     
          this. subscriptionComplete=true
          this.loadingSerchPlate = false
        }

        else {
          const translateTxtNotMatch = this.translate.instant("notMatchFound") 
          this.helperService.showAlert =true
            this.helperService.typeAlert ="error"
            this.helperService.messageAlert =translateTxtNotMatch
            setTimeout(() => {
              this.helperService.showAlert =false
              }, 7000)
          this.loadingSerchPlate = false
        }   }
      },
    })
  }

  fetchMoreAppointments() {
    this.currentPage++;
    this.loadingSerchPlate = true;
    this.customerSchedules$ = this.customScheduleService.getByPlateIdentification(
      "1",
      String(this.formValidation.value.placa),
      String(this.currentPage),
      "20",
      String(this.formValidation.value.document)
    ).pipe(
      catchError((error: any) => {
        this.loadingSerchPlate = false;
        return EMPTY;
      })
    );

    this.customerScheduleSubscribe = this.customerSchedules$.subscribe({
      next: (response) => {
        if (!response || response.length === 0) {
          this.hasMoreAppointments = false;
          this.loadingSerchPlate = false;
          return;
        }

        response.forEach((element) => {
          let date = element.start.split('T')[0];
          let time = element.start.split('T')[1];
          let formatTime = moment(time, 'HH:mm:ss').format('hh:mm A.');
          let splitTime = formatTime.split(' ');
          let customFormat = `${splitTime[0]} ${splitTime[1][0]}.${splitTime[1][1]}.`;

          element.time = customFormat;
          element.startDate = moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
          element.consultedSchedule = true;
        });
        
        this.scheduledAppointments.push(...response);
        this.visibleAppointments.push(...response);
        this.numberAppointments = this.scheduledAppointments.length;
        this.loadingSerchPlate = false;

        if (response.length < 20) {
          this.hasMoreAppointments = false;
        }
      }
    });
  }

  containsSpecialCharacters(value: string): boolean {
    // Verificar si el valor contiene algún carácter especial
    const specialCharsRegex = /[!@#$%^&*()+{}\[\]:;<>,?~\\/]/;
    return specialCharsRegex.test(value);
  }
  
  openDialog(appointment): void {
    if (this.isDisabledAppointment(appointment)) {
      this.openDialogInformation(appointment);
      return;
    }

    this.typeOfService = appointment.typeOfService
    let  scheduleId:any = appointment.id;
    const dialogRef = this.dialog.open(CancelAppointmentComponent, {
      width: '550px',
      data: scheduleId,
    });
    
    dialogRef.afterClosed().subscribe(result => {
      if (result.scheduleId === appointment.id) {
        this.isAppointmentCanceled = true; 
        this.numberAppointments = this.numberAppointments - 1 ;
        setTimeout(() => {
          const currentLanguage = this.translate.currentLang     
          const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}/${currentLanguage}`
          this.router.navigate([bannermanagementURL]);  
        }, 7000);
      }
      
    });
  }

  openDialogInformation(appointment): void {
    let  scheduleId:any = appointment.id;
    const dialogRef = this.dialog.open(InformationModalComponent, {
      width: '550px',
      data: scheduleId,
    });

    dialogRef.afterClosed().subscribe(result => {
      setTimeout(() => {
        const currentLanguage = this.translate.currentLang     
        const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}/${currentLanguage}`
        this.router.navigate([bannermanagementURL]);  
      }, 7000);
    });
  }

}
